<!-- Category field of the source and saved video dialogs (src/features/categories.ts): one pill per category, the fixed
     ones first, then the user's own (with their icon); one at a time, tapping the chosen one again leaves the item
     without a category. "Manage categories" opens CategoryDialog.vue above the dialog. Pills like PillGroup.vue
     (pill-btn, data-value = the stored id). -->
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'
import { useProfileData } from '../../composables/useProfileData'
import { useDialogsStore } from '../../stores/dialogs'
import { allKinds } from '../../features/categories'
import LookIcon from '../LookIcon.vue'
import type { CategoryGroup } from '../../data/types'

const props = defineProps<{ group: CategoryGroup; modelValue: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const { t } = useI18n()
const data = useProfileData()
const kinds = computed(() => allKinds(data.value, props.group))
const pick = (id: string) => emit('update:modelValue', props.modelValue === id ? '' : id)
</script>

<template>
  <div>
    <div class="flex flex-wrap gap-1.5">
      <button v-for="k in kinds" :key="k.id" type="button" :data-value="k.id"
        :class="['pill-btn inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-bold text-xs transition', modelValue === k.id ? 'bg-brand text-white' : 'bg-darkinput text-gray-400 hover:text-gray-100']"
        @click="pick(k.id)"><LookIcon :look="{ color: '', icon: k.icon }" cls="text-[10px]" img="w-3.5 h-3.5" />{{ k.name }}</button>
    </div>
    <button type="button" class="mt-2 text-[11px] font-bold text-gray-500 hover:text-brand" @click="useDialogsStore().show('categories', { group })"><i class="fas fa-sliders mr-1"></i>{{ t('Manage categories') }}</button>
  </div>
</template>
